import { apiConstants } from '../config';
let code = apiConstants.code;
let codeAPI = apiConstants.codeAPI;

const state = {
    error: null,
    loading: false,
    data: {
        code: code,
        codeAPI: codeAPI,
        module: {},
        panels: {
            home: {
                menu: {
                    route: `${code.replace(new RegExp(`${CITYHUB_MANAGE_SUFFIX}$`), '')}.home`,
                    text: 'home.title',
                    icon: 'fas fa-home',
                },
                acl: {
                    view: null,
                },
            },
            settings: {
                menu: {
                    route: `${code}.settings`,
                    text: `settings.titles`,
                    icon: 'fas fa-cogs',
                },
                acl: {
                    view                    : 'acl',
                    edit                    : 'acl',
                },
                url: {
                    getConfig               : `/${codeAPI}/:applicationCode/gestao/definitions`,
                },
            },
            default_layers: {
                menu: {
                    route: `${code}.default_layers`,
                    text: 'default_layers.titles',
                    icon: 'fas fa-layer-group',
                },
                acl: {
                    view                    : 'acl',
                    detail                  : 'acl',
                    add                     : 'acl',
                    edit                    : 'acl',
                    delete                  : 'acl',
                },
                url: {
                    getList                 : `${codeAPI}/:applicationCode/gestao/defaultlayers`,
                    getShow                 : `${codeAPI}/:applicationCode/gestao/defaultlayers/:id`,
                    getCreate               : `${codeAPI}/:applicationCode/gestao/defaultlayers`,
                    getUpdate               : `${codeAPI}/:applicationCode/gestao/defaultlayers/:id`,
                    getDelete               : `${codeAPI}/:applicationCode/gestao/defaultlayers/:id`,
                    getLists                : `${codeAPI}/:applicationCode/gestao/defaultlayers/lists`,
                    getResources            : `/backoffice/gestao/ogc/remoteservices/resources`,
                },
            },
            layers: {
                menu: {
                    route: `${code}.layers`,
                    text: `layers.titles`,
                    icon: 'fas fa-layer-group',
                },
                acl: {
                    view                    : 'acl',
                    detail                  : 'acl',
                    add                     : 'acl',
                    edit                    : 'acl',
                    delete                  : 'acl',
                    private                 : 'acl',
                },
                url: {
                    getGroups               : `${codeAPI}/:applicationCode/gestao/layers/groups`,
                    getList                 : `${codeAPI}/:applicationCode/gestao/layers`,
                    getShow                 : `${codeAPI}/:applicationCode/gestao/layers/:id`,
                    getCreate               : `${codeAPI}/:applicationCode/gestao/layers`,
                    getUpdate               : `${codeAPI}/:applicationCode/gestao/layers/:id`,
                    getDelete               : `${codeAPI}/:applicationCode/gestao/layers/:id`,
                    getOGCLists             : '/backoffice/gestao/ogc/lists',
                    getLists                : `${codeAPI}/:applicationCode/gestao/layers/lists`,
                    getResources            : `/backoffice/gestao/ogc/remoteservices/resources`,
                },
            },
            regulations: {
                menu: {
                    route: `${code}.regulations`,
                    text: `regulations.titles`,
                    icon: 'fas fa-book',
                },
                acl: {
                    view                    : 'acl',
                    detail                  : 'acl',
                    add                     : 'acl',
                    edit                    : 'acl',
                    delete                  : 'acl',
                },
                url: {
                    getList                 : `${codeAPI}/:applicationCode/gestao/regulations`,
                    getShow                 : `${codeAPI}/:applicationCode/gestao/regulations/:id`,
                    getCreate               : `${codeAPI}/:applicationCode/gestao/regulations`,
                    getUpdate               : `${codeAPI}/:applicationCode/gestao/regulations/:id`,
                    getDelete               : `${codeAPI}/:applicationCode/gestao/regulations/:id`,
                    getLists                : `${codeAPI}/:applicationCode/gestao/regulations/lists`,
                },
            },
            print_visible_emissions: {
                menu: {
                    route: `${code}.print_visible_emissions.config`,
                    text: `print_visible_emissions.titles`,
                    icon: 'fas fa-print',
                },
                acl: {
                    view                    : 'acl',
                    config                  : 'acl',
                    configEdit              : 'acl',
                },
                url: {
                    getList                 : `/${codeAPI}/:applicationCode/gestao/printvisible`,
                    getConfig               : `/${codeAPI}/:applicationCode/gestao/printvisible/settings`,
                    getApps                 : `/${codeAPI}/:applicationCode/gestao/printvisible/print/apps`,
                },
            },
        },
        tools: {
        },
    },
};

export default state;
